<template>
  <Modal v-model="setPostalCodeModal" :title="setPostalCodeTitle" width="500" :transfer="false" :mask-closable="setPostalCodeTalg === 'look'"
    @on-visible-change="setPostalCodeChange" :footer-hide="setPostalCodeTalg === 'look'">
    <Form ref="setPostalCodeForm" :disabled="setPostalCodeTalg === 'look'" :model="setPostalCodeForm"
      :rules="ruleValidate" :label-width="100" @submit.native.prevent>
      <Row style="width: 95%;">
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <div class="flex align-items-center mb20 font-size-12">
            <span class="width_94 text-align-right display-inline-block">{{ $t('key1001246') }}</span>
            <InputNumber
              style="width: 80px;"
              class="ml6 mr6"
              :max="999"
              :min="1"
              :formatter="value => `${parseInt(value)}`"
              v-model="setPostalCodeForm.interceptFirstNumber">
            </InputNumber>
            <span class="font-size-13">{{ $t('key1001247') }}</span>
          </div>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="labelText" prop="postalCode">
            <Input
              type="textarea"
              :placeholder="$t('key1001245')"
              :autosize="{ minRows: 6, maxRows: 12}"
              v-model.trim="setPostalCodeForm.postalCode">
            </Input>
          </Form-item>
        </Col>
      </Row>
    </Form>
    <template #footer>
      <Button @click="setPostalCodeModal = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" @click="setPostalCodeBtn">{{ $t('key1000555') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';

export default {
  name: 'setPostalCodeModal',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      twoCode: null,
      setPostalCodeModal: false,
      setPostalCodeForm: {
        interceptFirstNumber: null,
        postalCode: ''
      },
      ruleValidate: {
        postalCode: [
          {required: true, validator: v.validatePostalCode(), trigger: 'blur'}
        ],
      },
      setPostalCodeTalg: 'edit',
      setPostalCodeTitle: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001052')
    };
  },
  computed: {
    labelText() {
      let interceptFirstNumber = parseInt(this.setPostalCodeForm.interceptFirstNumber);
      return this.setPostalCodeForm.interceptFirstNumber !== null ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001240') + interceptFirstNumber + aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001241') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001242');
    }
  },
  methods: {
    // 初始化数据
    initSetPostalCodeData(obj, type) {
      this.twoCode = obj.twoCode;
      this.setPostalCodeTalg = type;
      this.setPostalCodeTitle = type === 'edit' ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001052') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001053');
      let postalCodeList = obj.postalCodeList || [];
      this.setPostalCodeForm.interceptFirstNumber = obj.interceptFirstNumber || null;
      if (postalCodeList.length > 0) {
        let str = postalCodeList.join('\n');
        this.setPostalCodeForm.postalCode = str;
      }
      this.setPostalCodeModal = true;
    },
    // 校验邮编
    validatePostalCode() {
      let v = this;
      let isnoMatchChinese = v.$regular.matchLettersNumbers;
      return function (rule, value, callback) {
        if (value === '') {
          callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001243')));
        } else if (!isnoMatchChinese.test(value)) {
          callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001244')));
        }
        callback();
      };
    },
    // 保存
    setPostalCodeBtn() {
      let v = this;
      v.$refs['setPostalCodeForm'].validate((valid) => {
        if (valid) {
          let list = [];
          let newList = v.sepCommasFn(v.setPostalCodeForm.postalCode, ['\n']);
          if (newList.length > 0) {
            newList.map((key) => {
              let txt = v.setPostalCodeForm.interceptFirstNumber !== null ? key.slice(0, v.setPostalCodeForm.interceptFirstNumber) : key;
              list.push(txt);
            });
            let params = {
              interceptFirstNumber: v.setPostalCodeForm.interceptFirstNumber,
              postalCodeList: newList,
              twoCode: v.twoCode
            };
            v.$emit('updatePostalCode', params);
            v.setPostalCodeModal = false;
          }
        }
      });
    },
    // 监听弹窗
    setPostalCodeChange(value) {
      if (!value) {
        this.$refs['setPostalCodeForm'].resetFields();
        this.setPostalCodeForm.interceptFirstNumber = null;
        this.twoCode = null;
        this.setPostalCodeTalg = 'edit';
      }
    }
  },
  watch: {},
  components: {}
};
</script>

<style lang="less">

</style>
